<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information flex-container2">
          <div class="flex">
            <div class="item flex-1">
              <ul class="menu2">
                <li class="on">登入者：{{ loginInfo ? loginInfo.id : "" }}</li>
                <div id="two_column">
                  <dl>
                    <dd style="background-color: transparent">
                      <p>
                        上次登入時間：{{
                          grid ? grid.lastLoginDate : ""
                        }}　密碼效期:{{ grid ? grid.lastPwdTimeSpan : "" }}
                        天後需更新密碼
                      </p>
                    </dd>
                    <!-- <dd style="background-color: transparent">
                      <select v-model="form.govCode1" style="min-width: 200px">
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                        disabled
                      >
                        {{ item.text }}
                      </option>
                    </select>
                      <input
                        type="submit"
                        class="btn"
                        value="切換機關"
                      />
                    </dd> -->
                  </dl>
                </div>
              </ul>
            </div>
            <div class="item flex-1">
              <ul class="menu2">
                <li class="on">內部公告</li>
                <div id="two_column">
                  <dl>
                    <dd
                      v-for="(data, index) in dropDownList.Notices"
                      :key="index"
                      @click="btnNoticeDetail(data)"
                      style="cursor: pointer"
                    >
                      <p class="date">{{ data.postDate }}</p>
                      <p optidx="0" class="description1 original">
                        {{ data.title }}
                      </p>
                    </dd>
                  </dl>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CyFooter />

    <Notice
      v-model="Notice.show"
      :title="Notice.grid.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="flex-container2">
          <div class="flex2">
            <div class="item2 p4">
              <!--  最新消息-->
              <div class="table_scroll2">
                <div id="two_column">
                  <dl>
                    <h3>公告日期：</h3>
                    <dd>
                      <p class="txt_01">
                        {{ Notice.grid.postDate }}
                      </p>
                    </dd>
                    <h3>標題：</h3>
                    <dd>
                      <p class="txt_01">{{ Notice.grid.title }}</p>
                    </dd>
                    <h3>內容：</h3>
                    <dd>
                      <p v-html="Notice.grid.content"></p>
                    </dd>
                    <h3>附件檔案：</h3>
                    <dd v-for="(data, index) in Notice.grid.file" :key="index">
                      <a
                        :href="
                          data.attR_STRING
                            ? data.attR_TYPE + ',' + data.attR_STRING
                            : '#'
                        "
                        :download="data.attR_NAME"
                      >
                        <p>{{ data.attR_NAME }}</p>
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Notice>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>


<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import {
  SearchGovCode,
  GetNotice,
  GetNoticeDetail,
  Index_SearchGrid,
} from "@/service/api.js";

export default {
  name: "P102",
  data: function () {
    return {
      pageData: {
        MenuIndex: 0,
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: sessionStorage.getItem("LoginInfo")
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      dropDownList: {
        govCode1s: [],
        Notices: [],
      },
      grid: {},
      form: {
        govCode1: sessionStorage.getItem("Session_GovCode")
          ? sessionStorage.getItem("Session_GovCode")
          : sessionStorage.getItem("LoginInfo") ? JSON.parse(sessionStorage.getItem("LoginInfo")).govCodeStr.split(',')[0]
          : "",
      },
      Notice: {
        show: false,
        title: "",
        grid: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Notice: VueModal,
    Alert: VueModal,
  },
  methods: {
    // //取得服務機關第一層類別
    // getSearchGovCode1: function () {
    //   const self = this;
    //   let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
    //   SearchGovCode(GovCode).then((rData) => {
    //     self.dropDownList.govCode1s = rData.returnObject;
    //   });
    // },
    getIndex: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        id: self.loginInfo ? self.loginInfo.id : "",
        rolE_SEQ: self.loginInfo ? self.loginInfo.roleSeq : 0,
      };
      Index_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        // sessionStorage.setItem("RoleAuthorizeMenu", JSON.stringify(self.grid.roleAuthorizeMenu));
      });
    },
    //取得公告
    getNoticeData: function () {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postNode: "2",
      };
      GetNotice(postData).then((returnData) => {
        self.dropDownList.Notices = returnData.returnObject.notices;
        self.dropDownList.Notices.forEach(
          (x) => (x.postDate = self.$moment(x.posT_DATE).format("YYYY/MM/DD"))
        );
      });
    },
    btnNoticeDetail: function (data) {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postSeq: data.posT_SEQ,
      };
      GetNoticeDetail(postData).then((returnData) => {
        self.Notice.grid = returnData.returnObject.noticeDetails[0];
        self.Notice.grid.postDate = self
          .$moment(self.Notice.grid.posT_DATE)
          .format("YYYY/MM/DD HH:mm:ss");
        self.Notice.show = true;
      });
    },
  },
  created() {
    //this.getSearchGovCode1();
    this.getNoticeData();
    this.getIndex();
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
